module.exports = __webpack_public_path__ + "img/icon_service_24.96d87bff.svg";